/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_Empty_BodyInputs */

const en_landing_calendar_empty_body = /** @type {(inputs: Landing_Calendar_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call and we will find you a time.`)
};

const pl_landing_calendar_empty_body = /** @type {(inputs: Landing_Calendar_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadzwoń, a znajdziemy Ci termin.`)
};

/**
* | output |
* | --- |
* | "Call and we will find you a time." |
*
* @param {Landing_Calendar_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_empty_body = /** @type {((inputs?: Landing_Calendar_Empty_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_Empty_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_empty_body(inputs)
	return en_landing_calendar_empty_body(inputs)
});